<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="epigraph">
<p class="epi"><span aria-label="vi" epub:type="pagebreak" id="page_vi" role="doc-pagebreak" title="vi"><span aria-label="vii" epub:type="pagebreak" id="page_vii" role="doc-pagebreak" title="vii">We’re all stories, in the end. Just make it a good one, eh?</span></span></p>
<p class="epi-att">—The Doctor</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?6b11bbda